/* eslint-disable no-nested-ternary */

import { ReactNode } from 'react';
import Image from 'next/image';

import { ButtonV1 } from '@northladder/design-system';
import { Text } from '@northladder/i18n';
import { TTextLocalized } from '@northladder/utilities';

interface IAssessmentContentProps {
  heroImageURL?: string;
  HeroAnimation?: ({ className }: { className: string }) => ReactNode;
  title: TTextLocalized;
  subTitle?: TTextLocalized;
  button?: {
    label?: TTextLocalized;
    onClick: () => void;
  };
  altButton: {
    leadingText?: TTextLocalized;
    label?: TTextLocalized;
    onClick: () => void;
  };
}

export function AssessmentContent({
  heroImageURL,
  HeroAnimation,
  title,
  subTitle,
  button,
  altButton,
}: IAssessmentContentProps) {
  return (
    <main className="flex min-h-[calc(100vh-230px)] items-center justify-center">
      <div className="mx-auto my-auto max-w-4xl px-4 pb-8 text-center sm:px-6 lg:px-8">
        {HeroAnimation ? (
          <HeroAnimation className="my-10 h-60 w-full object-contain object-center" />
        ) : heroImageURL ? (
          <Image
            alt="Front Image"
            className="my-10 h-60 w-full object-contain object-center"
            height={1200}
            src={heroImageURL}
            width={600}
          />
        ) : null}
        <div className="mx-auto flex max-w-sm flex-col items-center py-8 md:max-w-2xl">
          <h1 className="text-md text-primary-700 w-2/3 font-normal tracking-tight">
            <Text text={title} />
          </h1>
          {subTitle ? (
            <p className="text-primary-900 mt-4 hidden w-2/3 max-w-xl text-sm  font-light ">
              <Text text={subTitle} />
            </p>
          ) : null}
        </div>

        {button ? (
          <div className="flex w-full justify-end">
            <ButtonV1
              className="mx-auto my-4 w-full sm:w-auto"
              isEnabled
              isLoading={false}
              label={button.label || 'Start'}
              onClick={button.onClick}
              type="button"
            />
          </div>
        ) : null}

        {altButton ? (
          <p className="text-sm font-light text-gray-500 dark:text-gray-400">
            <Text text={altButton.leadingText || ''} />

            <button
              className="form-link-action ms-2"
              onClick={altButton.onClick}
              type="button"
            >
              <Text text={altButton.label || 'Restart Assessment'} />
            </button>
          </p>
        ) : null}
      </div>
    </main>
  );
}
